import React from 'react';
import { createBrowserRouter } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import ContactLayout from '../layouts/ContactLayout';
// import VolunteerLayout from '../layouts/VolunteerLayout';
import Home from '../pages/Home';
import About from '../pages/About';
import Blogs from '../pages/Blogs';
import BlogArticle from '../pages/BlogArticle';
import Careers from '../pages/Careers';
import Contact from '../pages/Contact';
import Volunteers from '../pages/Volunteers';
import PrivacyPolicy from '../pages/PrivacyPolicy';
import TermsOfService from '../pages/TermsOfService';
import CookiePolicy from '../pages/CookiePolicy';
import Services from '../pages/Services';
import GovernmentSolutions from '../pages/GovernmentSolutions';
import Products from '../pages/Products';
import NotFound from '../pages/NotFound';
import ErrorPage from '../pages/ErrorPage';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <MainLayout />,
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: 'about',
        element: <About />,
      },
      {
        path: 'services',
        element: <Services />,
      },
      {
        path: 'government-solutions',
        element: <GovernmentSolutions />,
      },
      {
        path: 'products',
        element: <Products />,
      },
      {
        path: 'blog',
        element: <Blogs />,
      },
      {
        path: 'blogs',
        element: <Blogs />,
      },
      {
        path: 'blog/:slug',
        element: <BlogArticle />,
      },
      {
        path: 'careers',
        element: <Careers />,
      },
      {
        path: 'privacy-policy',
        element: <PrivacyPolicy />,
      },
      {
        path: 'terms-of-service',
        element: <TermsOfService />,
      },
      {
        path: 'cookie-policy',
        element: <CookiePolicy />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
  // {
  //   path: '/volunteers',
  //   element: <VolunteerLayout />,
  //   errorElement: <ErrorPage />,
  //   children: [
  //     {
  //       index: true,
  //       element: <Volunteers />,
  //     },
  //   ],
  // },
  {
    path: '/contact',
    element: <ContactLayout />,
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <Contact />,
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
]);


